import { FC } from 'react';

import { ColorDot } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';
import { Stock, StockLevelStatuses } from '@telialt/models/src/EshopModel';

import { ESHOP_TEST_ID } from '../test/test-ids';
import { CurrentStockStatusContainer, StockSubtext } from './ProductStockStatus.styles';
import { ProductStockText } from './StockText';

type Props = {
    stock: Stock;
};

export const CurrentStockStatus: FC<Props> = ({ stock }) => {
    const { t } = useTranslations();

    const isOutOfStock = stock?.stockLevelStatus === StockLevelStatuses.NoStock;
    const isLowStock = stock?.stockLevelStatus === StockLevelStatuses.LowStock;

    const dotColor = getPurpurColor((isOutOfStock && 'red600') || (isLowStock && 'orange500') || 'green600');

    return (
        <CurrentStockStatusContainer $isOutOfStock={isOutOfStock} data-test={ESHOP_TEST_ID.PRODUCT_STOCK_STATUS}>
            <ColorDot color={dotColor} size="xs" />
            <ProductStockText stock={stock} />
            {!isOutOfStock && <StockSubtext>{t['eshop.product_page.stock_status.delivery_time']}</StockSubtext>}
        </CurrentStockStatusContainer>
    );
};
